import { useMemo, useState, useEffect } from 'react'
import useAxios from 'axios-hooks'

const namespace = 'scholarships-stage'

export const useDelete = () => {
  const [deleteId, setDeleteId] = useState()

  const [{ data, loading, error }, sendDelete] = useAxios({
    method: 'DELETE',
    url: `${namespace}/${deleteId}`,
  }, { manual: true })

  useEffect(() => {
    if (deleteId) {
      sendDelete()
    }
  }, [deleteId])

  return useMemo(() => ({
    data,
    loading,
    error,
    deleteRecord: setDeleteId,
  }), [
    data,
    loading,
    error,
    setDeleteId,
  ])
}
